import styled from '@emotion/styled';
import {
  Button,
  SvgIcon,
  SvgNames,
  Typography,
  tokens,
} from '@sunrun/experience-ui-components';

const PipelineErrorDisplay = ({
  isListViewRoute,
  setCurrentView,
  currentView,
  isEmptyState = false,
  onClearFilters,
}: {
  isListViewRoute: boolean;
  setCurrentView: (view: 'pipeline' | 'list') => void;
  currentView: 'pipeline' | 'list';
  isEmptyState?: boolean;
  onClearFilters?: () => void;
}) => {
  return (
    <EmptyState>
      <div>
        {isEmptyState ? (
          <StyledSvgContainer>
            <SvgIcon
              name={SvgNames.Search}
              width={32}
              height={32}
              color={tokens.BRAND_HERO_BLUE}
            />
          </StyledSvgContainer>
        ) : (
          <SvgIcon
            name={SvgNames.ErrorOutline}
            width={32}
            height={32}
            color={tokens.TINTS_ERROR_40}
          />
        )}
      </div>
      {!isEmptyState && (
        <div>
          <Typography align="center">
            Sorry we couldn't load the{' '}
            {currentView === 'list' ? 'List View' : 'Pipeline'} right now.
          </Typography>
          <Typography align="center">
            Please try refreshing
            {!isListViewRoute
              ? ` or going to the ${
                  currentView === 'pipeline' ? 'List View' : 'Pipeline'
                }`
              : ''}
            .
          </Typography>
        </div>
      )}
      {isEmptyState && currentView === 'list' && (
        <div>
          <Typography align="center">
            No results found for your search.
          </Typography>
          <Typography align="center">
            Try using a different search, apply different filters, change the
            date range, or search in Pipeline.
          </Typography>
        </div>
      )}
      {!isEmptyState && (
        <Button
          color="secondary"
          size="sm"
          onClick={() => {
            window.location.reload();
          }}>
          Refresh
        </Button>
      )}
      {isEmptyState && currentView === 'list' && onClearFilters && (
        <Button
          color="secondary"
          size="sm"
          onClick={() => {
            onClearFilters();
          }}>
          Clear Search
        </Button>
      )}
      {!isListViewRoute && (
        <Button
          color="link"
          onClick={() => {
            setCurrentView(currentView === 'pipeline' ? 'list' : 'pipeline');
          }}>
          Go to {currentView === 'pipeline' ? 'List View' : 'Pipeline'}
        </Button>
      )}
    </EmptyState>
  );
};

const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  justify-content: center;
  align-items: center;
  height: calc(100% - 164px);
  width: 100%;
`;

const StyledSvgContainer = styled.div`
  padding: 7px;
  border-radius: 50%;
  background-color: ${tokens.TINTS_HERO_BLUE_90};
`;

export { PipelineErrorDisplay };
